import { motion } from "framer-motion";
import { BRAND_STRIP } from "../lib/data";

export default function LogoMarquee({ label, compact = false, className = "", duration = 42 }) {
  const scale = compact ? 0.82 : 1;
  const items = [...BRAND_STRIP, ...BRAND_STRIP];
  return (
    <div className={`overflow-hidden ${className}`} data-testid="logo-marquee">
      {label && (
        <div className="mx-auto max-w-[1600px] px-6 sm:px-10 mb-8">
          <span className="label !text-silver/60">{label}</span>
        </div>
      )}
      <div className="relative w-full overflow-hidden">
        <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-16 sm:w-28 z-10 bg-gradient-to-r from-ink to-transparent" />
        <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-16 sm:w-28 z-10 bg-gradient-to-l from-ink to-transparent" />
        <motion.div
          className="flex w-max items-center gap-14 sm:gap-24"
          animate={{ x: ["0%", "-50%"] }}
          transition={{ duration, ease: "linear", repeat: Infinity }}
        >
          {items.map((b, i) => (
            <span
              key={i}
              className="flex items-center justify-center shrink-0"
              style={{ height: `${b.h * scale}px` }}
              data-testid={`brand-${i}`}
            >
              <img
                src={b.src}
                alt={b.name}
                loading="eager"
                draggable="false"
                className="h-full w-auto object-contain opacity-60 transition-opacity duration-500 hover:opacity-100"
              />
            </span>
          ))}
        </motion.div>
      </div>
    </div>
  );
}
